import React, { useEffect } from 'react';

import { fetchAuthenticated, get } from 'services/fetch';
import { emitEvent } from 'utils/events';

import EquipmentColorForm from 'components/forms/EquipmentColorForm';
import { logAction } from 'utils/logs';

export default function NewEquipmentColor(props) {
  const { history, setBreadcrumbs } = props;

  // Set breadcrumbs
  useEffect(() => {
    setBreadcrumbs([
      { path: '/cadastros/cores', label: 'Cores' },
      { path: '', label: 'Nova Cor' }
    ]);
    return () => setBreadcrumbs([]);
  }, [setBreadcrumbs])

  // Handle form submit
  const handleSubmit = async (data) => {
    const response = await fetchAuthenticated('post', 'equipment-color', data);

    if (!response.ok) {
      throw new Error('');
    } else {
      const data = await response.json();
      if (data) {
        for (const c of data) {
          logAction(`Criação da cor ${c.name}`);
        }
      }
      emitEvent('showSnack', { message: 'Cor criada com sucesso', type: 'success' });
      history.push(`/cadastros/cores`);
    }
  }

  // Handle cancel click
  const handleCancel = async () => {
    history.push('/cadastros/cores');
  }


  return (
    <div>
      <EquipmentColorForm
        title='Nova Cor'
        handleCancel={handleCancel}
        handleSubmit={handleSubmit}
      />
    </div>
  )
}
